export const CUSTOM_OFFER_TOKEN_STORAGE_KEY = 'avyna.onboarding.customOfferToken';
